import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { XCircle } from "lucide-react";

const REASONS = [
  "Preço muito alto",
  "Sem orçamento no momento",
  "Escolheu concorrente",
  "Não respondeu",
  "Fora do perfil",
  "Timing errado",
];

export default function LossModal({ open, onCancel, onConfirm, leadName }) {
  const [selected, setSelected] = useState("");
  const [custom, setCustom] = useState("");

  const handleConfirm = () => {
    const reason = selected === "Outro" ? custom.trim() : selected;
    if (!reason) return;
    onConfirm(reason);
    setSelected("");
    setCustom("");
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <DialogContent data-testid="loss-modal" className="bg-slate-900 border-slate-800 text-slate-100 max-w-md">
        <DialogHeader>
          <div className="w-12 h-12 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center mb-3">
            <XCircle className="w-6 h-6 text-red-400" />
          </div>
          <DialogTitle className="text-slate-50" style={{ fontFamily: "Outfit" }}>
            Motivo da Perda
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            Informe por que <span className="text-slate-200 font-semibold">{leadName}</span> foi perdido.
            Isso ajuda a entender padrões e melhorar a conversão.
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-2 gap-2 my-3">
          {[...REASONS, "Outro"].map((r) => (
            <button
              key={r}
              data-testid={`loss-reason-${r}`}
              onClick={() => setSelected(r)}
              className={`text-left px-3 py-2 rounded-lg text-sm border transition ${
                selected === r
                  ? "bg-red-500/10 border-red-500/60 text-red-200"
                  : "bg-slate-800/60 border-slate-700 text-slate-300 hover:border-slate-500"
              }`}
            >
              {r}
            </button>
          ))}
        </div>

        {selected === "Outro" && (
          <Textarea
            data-testid="loss-reason-custom"
            placeholder="Descreva o motivo..."
            value={custom}
            onChange={(e) => setCustom(e.target.value)}
            className="bg-slate-800 border-slate-700 text-slate-100 placeholder-slate-500"
          />
        )}

        <DialogFooter className="gap-2">
          <Button
            data-testid="loss-cancel"
            variant="ghost"
            onClick={onCancel}
            className="text-slate-300 hover:bg-slate-800"
          >
            Cancelar
          </Button>
          <Button
            data-testid="loss-reason-submit"
            onClick={handleConfirm}
            disabled={!selected || (selected === "Outro" && !custom.trim())}
            className="bg-red-500 hover:bg-red-600 text-white"
          >
            Registrar Perda
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
